import styled from "styled-components";
import { useState, useContext, useEffect, createContext } from "react";
import { listenToOrgTreeDatabase } from "../Firebase";
import { CurrentUserContext } from "./CurrentUserContext";

export const OrgTreeContext = createContext<OrgTreeItem | null>(null);

export default function OrgTreeContextProvider(props: Props) {
  const currentUser = useContext(CurrentUserContext);
  const firebaseUser = currentUser?.currentFirebaseUser;
  const [orgTreeData, setOrgTreeData] = useState<OrgTreeItem | null>(null);

  useEffect(() => {
    if (!currentUser?.currentFirebaseUser) return;
    const unsubscribeFromOrgTree = listenToOrgTreeDatabase((data) => {
      data && setOrgTreeData(data);
    });

    return () => {
      unsubscribeFromOrgTree();
    };
  }, [firebaseUser]);

  return (
    <OrgTreeContext.Provider value={orgTreeData}>
      {props.children}
    </OrgTreeContext.Provider>
  );
}

interface Props {
  children: React.ReactNode;
}
